import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TextField } from '../../../models/textfield' 

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.css']
})
export class TextFieldComponent implements OnInit {
  @Input() textField: TextField = {
    label: '',
    type: '',
    for: '',
    id: '',
    name: '',
    model: '',
    placeholder: ''
  };
  constructor() { }

  ngOnInit() {
  }

}
